export default __webpack_public_path__ + "static/media/profile.77bbb6d9.png";